import React, { useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Dialog, DialogContent } from '../../UI/Modal/ModalPrimitive'
import FbButton, { FbButtonVariants } from '../../FbUI/FbButton'
import { ContactRequestProvider } from './ContactRequestContext'
import { StepManager } from './components/StepManager'

interface ContactRequestJobFromCampaignModalProps {
  campaignId: number
  isMultiType?: boolean
  buttonText?: string
  variant?: FbButtonVariants
  onContactRequested?: () => void
  disabled?: boolean
  disabledTooltipText?: string
  /** Controlled open state — when provided, the modal is opened externally (no button rendered) */
  externalOpen?: boolean
  onExternalClose?: () => void
}

export const ContactRequestJobFromCampaignModal: React.FC<
  ContactRequestJobFromCampaignModalProps
> = ({
  campaignId,
  isMultiType = false,
  buttonText = 'Request Contacts',
  variant = 'primary',
  onContactRequested,
  disabled = false,
  disabledTooltipText,
  externalOpen,
  onExternalClose,
}) => {
  const [internalOpen, setInternalOpen] = useState(false)
  const isControlled = externalOpen !== undefined
  const open = isControlled ? externalOpen : internalOpen

  const handleOpen = () => {
    if (!disabled) {
      setInternalOpen(true)
    }
  }
  const handleClose = () => {
    setInternalOpen(false)
    onExternalClose?.()
  }

  const button = (
    <FbButton variant={variant} onClick={handleOpen} disabled={disabled}>
      {buttonText}
    </FbButton>
  )

  return (
    <>
      {!isControlled &&
        (disabled && disabledTooltipText ? (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="tooltip-request-contacts-disabled">
                {disabledTooltipText}
              </Tooltip>
            }
          >
            <div>{button}</div>
          </OverlayTrigger>
        ) : (
          button
        ))}

      <Dialog open={open} onOpenChange={(open) => !open && handleClose()}>
        <DialogContent id={'fb-modal-content'} size="2xl">
          <ContactRequestProvider
            campaignId={campaignId}
            isMultiType={isMultiType}
            handleClose={handleClose}
            onContactRequested={onContactRequested}
          >
            <StepManager />
          </ContactRequestProvider>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default ContactRequestJobFromCampaignModal
